export const iconFontAwesomeTransportationTruck = (
	<i className="fa-solid fa-truck"></i>
);
